import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import {
  Card,
  Box,
  Typography,
  Button,
  CircularProgress,
  Chip,
  Divider,
  Grid,
} from "@mui/material";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { API_ENDPOINTS } from "../../../config/api";

const API_URL = API_ENDPOINTS.PRODUCTS.BASE;

// Placeholder image URL (use a real placeholder image URL or host one)
const PLACEHOLDER_IMAGE = "https://via.placeholder.com/400x400?text=No+Image";

const ProductDetailsContent = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = async () => {
    try {
      const response = await axios.get(`${API_URL}/${id}`);
      setProduct(response.data.product);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product details:", error);
      setLoading(false);
    }
  };

  const formatPriceForDisplay = (price) => {
    const parsedPrice = parseFloat(price);
    return isNaN(parsedPrice) ? "0.00" : parsedPrice.toFixed(2);
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 10 }}>
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (!product) {
    return (
      <Typography variant="h6" sx={{ textAlign: "center", mt: 10, color: "error.main" }}>
        Product not found
      </Typography>
    );
  }

  return (
    <Box component="section" className="dd" sx={{ p: { xs: 2, md: 4 }, bgcolor: "white", }}>
      
    <Box sx={{ mb: 3, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <h2>{product.product_name}</h2>
      <Link className="position-button" to="/products-list">
        <Button
          variant="contained"
          color="secondary"
          endIcon={<ArrowForwardIcon />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: "medium",
            "&:hover": {
              bgcolor: "primary.light",
              borderColor: "primary.main",
            },
          }}
        >
          Back to Products
        </Button>
      </Link>
    </Box>

       

        <Divider sx={{ mb: 4, borderColor: "grey.300" }} />

        <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                bgcolor: "grey.100",
                borderRadius: "12px",
                p: 2,
              }}
            >
              <img
                src={product.product_photo || PLACEHOLDER_IMAGE}
                alt={product.product_name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "450px",
                  objectFit: "contain",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease-in-out",
                }}
                onError={(e) => (e.target.src = PLACEHOLDER_IMAGE)}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={8}>
          

         <Box sx={{ mb: 3, display: "flex", justifyContent: "start", alignItems: "center" }}>
      <Typography component="p" variant="p" sx={{ color: "text.secondary", fontWeight: "medium", marginRight:"20px" }}>
        Brand:
      </Typography>
      <Typography component="p" variant="p"> {product.brand?.name || " - "}</Typography>
    </Box>

            <Box sx={{ mb: 3, display: "flex", justifyContent: "start", alignItems: "center" }}>
      <Typography component="p" variant="p" sx={{ color: "text.secondary", fontWeight: "medium", marginRight:"14px" }}>
        Region:
      </Typography>
         <Typography component="p" variant="p">{product.region?.name || " - "}</Typography>
              
            </Box>

             <Box sx={{ mb: 3, display: "flex", justifyContent: "start", alignItems: "center" }}>
             <Typography component="p" variant="p" sx={{ color: "text.secondary", fontWeight: "medium", marginRight:"8px" }}>
                Category:
              </Typography>
              <Typography  component="p" variant="p">{product.category?.name || " - "}</Typography>
            </Box>

        <Box sx={{ mb: 3, display: "flex", justifyContent: "start", alignItems: "center" }}>
             <Typography component="p" variant="p" sx={{ color: "text.secondary", fontWeight: "medium", marginRight:"8px" }}>
                Price: 
              </Typography>
              <Typography component="p" variant="p" sx={{ color: "success.main", fontWeight: "bold" }}>
                {formatPriceForDisplay(product.price)}/-
              </Typography>
            </Box>
            <Chip
                label={product.publish ? "Published" : "Unpublished"}
                color={product.publish ? "success" : "default"}
                size="medium"
                sx={{ fontWeight: "medium" }}
              />

          
          </Grid>

        
        </Grid>

          <Box sx={{ mt: 4 }}>
              <Typography variant="p" component="p" sx={{ color: "text.secondary", fontWeight: "medium" }}>
                Description :
              </Typography>
              <Typography
                variant="p"
                component="p"
                sx={{ color: "text.secondary", lineHeight: 1.8, mt: 1 }}
              >
                {product.description}
              </Typography>
            </Box>
      
    </Box>
  );
};

export default ProductDetailsContent;